<template>
  <div>
    <headNav></headNav>
    <div  style="height: 50px;"></div>
    <div>
      <img src="../assets/wdtb.jpg" class="img-responsive" />
    </div>



    <div class="container" style="margin-top: 24px;">
      <div class="row">
        <div class="col-md-3 visible-lg-block visible-md-block">

          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/publicHead.png" class="img-responsive" />
          </div>
          <div style="width: 100%;" class="btn-group-vertical " role="group">
            <router-link to="/dszzc"><button type="button" class="btn btn-default btn-block">董事长致辞</button></router-link>
            <router-link to="/gsjj"><button type="button" class="btn btn-default btn-block">公司简介</button></router-link>
            <router-link to="/wdjf"><button type="button" class="btn btn-default btn-block">威盾技防</button></router-link>
            <router-link to="/fwfw"> <button type="button" class="btn btn-default btn-block">服务范围</button></router-link>
            <router-link to="/xmzs"><button type="button" class="btn btn-default btn-block">项目展示</button></router-link>
            <button type="button" class="btn btn-primary btn-block">威盾特保</button>
            <router-link to="/xwdt"><button type="button" class="btn btn-default btn-block">新闻动态</button></router-link>
            <router-link to="/bzzl"><button type="button" class="btn btn-default btn-block">报纸专栏</button></router-link>
            <router-link to="/hyxw"><button type="button" class="btn btn-default btn-block">行业新闻</button></router-link>
          </div>
          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/hezuo.png" class="img-responsive" />
          </div>

        </div>
        <div class="col-md-9 text-left">
          <h2 style="font-weight: bold;margin-top: 0px;">威盾特保</h2>
          <span>威盾官网 2021-11-16</span>
          <div style="margin-top: 10px;text-indent: 2em;">
            <p class="span16">特保是特定产品过渡性保障机制 和 特殊保障措施 的简称。特保指的是贴身保护政治人物、政府高官、企业家、艺人以及证人等重要人物，
              以防止其遭暗杀、绑架、攻击、骚扰及外泄机密等。</p>
            <p class="span16">特保是给一个人提供完全性的保安服务，要提供完全性的保安服务自然身手不该处于特警能力之下，而完全性则意味着长时间的保持警觉意识，考
              虑到雇主不曾想到的种种危险因素，为雇主赢得安全感，不让雇主的受到伤害。</p>
            <p class="span16">特保要赶在人身安全和财产安全受到损失之前发现问题，并及时予以处理。特保要预料到即将发生的危机状况，赶在危机发生之前或危机发生之时
              让损失降到最小，或者不受损失。</p>
            <img style="margin-bottom: 10px;width: 920px;" class="img-responsive" src="../assets/wdtb_one.png">
            <p class="span16">河南威盾保安服务公司 ，专业的安全管理团队，一支由特种兵，武术学院组建的特保队员，经过严格的军事化,专业化培训上岗。为大型活动、
              展览、文艺演出、体育赛事、企业、商界高层及名人要人提供全球化高级安保服务，提供全程化安全护卫方案，保障企业家、名人，影视明星，家庭， 企业，团队的人身和财产安全。</p>
            <img style="margin-bottom: 10px;width: 920px;" class="img-responsive" src="../assets/wdtb_two.png">
            <img style="margin-bottom: 10px;width: 920px;" class="img-responsive" src="../assets/wdtb_three.png">
            <p class="span16" style="padding-left: 28px;text-indent: 0em;">包含业务：<br>
              一、私人安全随行特保---主要负责个人人身安全；
              <br>
              二、商务安全贴身顾问----负责个人人身安全、行程安排、文秘助理、专职司机等；
              <br>
              三、临时安全顾问随行特保---重要会议、论坛、新闻发布会、大型展会、演出、演唱会、首映式、歌友会等大型活动场地；
              <br>
              四、定点守护安全特保：高档豪宅、别墅、高级商务会所定点护卫、办公区域定点护卫；
              <br>
              五、特保接送和车辆服务:适用于(学校，幼儿园，养老院)可按天，按人，按月，按年，专人(多名安全特卫)专车接送到目的地；
              <br>
              六、为VIP高端客户提供机场专车接送。
            </p>

          </div>
        </div>
      </div>
    </div>
     <Base></Base>
  </div>

</template>

<script>
  $(function() {

  });

  export default {
    data() {
      return {

      }
    },
    methods: {}




  }
</script>

<style>
  .btn-block {
    border-radius: 0px;
    height: 49px;
  }
  .row{
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/wdtb.vue